export const MainColor = "#316ba2";
export const SecondaryColor = "#d45019";